/**
 * @description: 报修审批设置
 * @author: hwx
 * @update: lyr
 */
<template>
	<div class="repair-check-wrap">
		<div class="repc-list" v-show="showList">
			<el-col class="row-margin">
				<el-button type="primary" @click="repcAdd">新增报修审批</el-button>
			</el-col>
			<el-form :inline="true" :model="repc_list_form" class="repc-list-form">
				<el-form-item label="门店">
					<el-select v-model="repc_list_form.shop_id" filterable clearable placeholder="请选择门店">
						<el-option v-for="item in shop_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="repcQuery">查询</el-button>
				</el-form-item>
			</el-form>
			<el-table
				v-loading="loading"
    			element-loading-text="努力加载中，请稍后..."
				element-loading-background="rgba(0, 0, 0, 0.6)"
				:data="repc_list">
				<el-table-column prop="shop_name" label="门店"></el-table-column>
				<el-table-column prop="name" label="规则名称"></el-table-column>
				<el-table-column label="使用日期">
					<template slot-scope="scope">
						<span v-if="scope.row.use_every_day == '1'">每天</span>
						<span v-else>{{scope.row.use_date}}</span>
					</template>
				</el-table-column>
				<el-table-column label="使用时间">
					<template slot-scope="scope">
						<span v-if="scope.row.use_all_day == '1'">全天</span>
						<span v-else>{{scope.row.use_time}}</span>
					</template>
				</el-table-column>
				<el-table-column label="操作">
					<template slot-scope="scope">
						<span class="text-blue" @click="repcModify(scope.row.id)">修改</span>
						<span class="text-blue" @click="repcDel(scope.row.id)">删除</span>
					</template>
				</el-table-column>
			</el-table>
			<el-pagination
				background
				layout="total, prev, pager, next, jumper"
				:page-size="GLOBAL.PAGESIZE"
				:current-page.sync="repc_list_page"
				:total="repc_list_total"
				@current-change="getRepcList">
			</el-pagination>
		</div>
		<div class="repc-edit" v-show="!showList">
			<div class="page-tit">{{edit_tit}}</div>
			<el-form ref="edit_form" :model="edit_form" label-width="120px">
				<el-form-item label="规则名称">
					<el-input placeholder="请输入规则名称" v-model="edit_form.name"></el-input>
				</el-form-item>
				<el-form-item label="门店">
					<el-select v-model="edit_form.shop_id" :disabled="edit_form.shop_disabled" filterable placeholder="请选择门店" @change="getCheck">
						<el-option v-for="item in shop_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="使用日期" class="repair-edit-usedate">
					<div ref="use_date_dom">
						<el-input v-model="edit_form.edit_usedate_txt" placeholder="请选择使用日期" readonly></el-input>
					</div>
				</el-form-item>
				<el-form-item label="使用时间">
					<el-input v-model="edit_form.edit_usetime_txt" placeholder="请选择使用时间" readonly @click.native="openUsetime"></el-input>
				</el-form-item>
				<el-form-item label="审批人">
					<el-select v-model="edit_form.check_id" filterable placeholder="请选择审批人">
						<el-option v-for="item in check_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
					</el-select>
					<el-button type="text" @click="chechAdds">增加审批人</el-button>
				</el-form-item>
				<el-form-item label="审批人" v-for="(item, index) in chech_adds" :key="index">
					<el-select v-model="item.check_id" filterable placeholder="请选择审批人">
						<el-option v-for="item in check_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
					</el-select>
					<el-button type="text" @click="checkDel(index)">删除</el-button>
				</el-form-item>
				<el-form-item>
					<el-button @click="backList">返回</el-button>
					<el-button type="primary" @click="editSub">确定</el-button>
				</el-form-item>
			</el-form>
			<!-- 使用时间 -->
			<div class="use-time-wrap" ref="repc_usetime_alert">
				<div>
					<input type="checkbox" v-model="usetime_allday">
					<label>全天</label>
				</div>
				<h2>开始时间：</h2>
				<select ref="starthour"></select>
				<label class="colon">:</label>
				<select ref="startseconds"></select>
				<h2>结束时间：</h2>
				<select ref="stophour"></select>
				<label class="colon">:</label>
				<select ref="stopseconds"></select>
			</div>
		</div>
	</div>
</template>

<script>
	import Vue from 'vue';
	export default {
		name: '',
		data() {
			return {
				showList: true,
				showUsetime: false,
				modify: '1',
				loading: false,
				shop_list: [],
				repc_list_form: {
					shop_id: '',
				},
				repc_list: [],
				repc_list_page: 1,
				repc_list_total: 0,

				edit_id: '',
				edit_tit: '',
				edit_form: {
					name: '',
					shop_id: '',
					shop_disabled: false,
					edit_usedate_txt: '',
					use_every_day: '-1',
					start_date: '',
					end_date: '',
					edit_usetime_txt: '',
					use_all_day: '-1',
					start_time: '',
					end_time: '',
					check_id: '',
				},
				usetime_allday: false,
				check_list: [],
				chech_adds: [],
				form: {},
			}
		},
		watch: {
			usetime_allday(val, oldVal) {
				if(val) {
					$(this.$refs.starthour).attr('disabled', true);
					$(this.$refs.startseconds).attr('disabled', true);
					$(this.$refs.stophour).attr('disabled', true);
					$(this.$refs.stopseconds).attr('disabled', true);
				} else {
					$(this.$refs.starthour).attr('disabled', false);
					$(this.$refs.startseconds).attr('disabled', false);
					$(this.$refs.stophour).attr('disabled', false);
					$(this.$refs.stopseconds).attr('disabled', false);
				}
			},
		},
		mounted: function() {
			this.getShop();
			this.getRepcList(1);

			this.initDate();
			this.initTime();
		},
		methods: {
			// 获取门店数据
			getShop: function() {
				const _this = this;

				Vue.axios.post('PublicData/api_getShopListByPurview', {
					"header": Vue.request_header,
					"request": {
						"param": {}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						_this.shop_list = res.data.response.result;
						_this.shop_list.shift();
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg('出错啦');
				});
			},
			// 使用日期
			initDate: function() {
				const _this = this;
				$(_this.$refs.use_date_dom).daterangepicker({
					parentEl: '.repair-edit-usedate',
					// drops: 'up',
					buttonClasses: ['btn btn-default'],
					applyClass: 'btn-small btn-orange',
					cancelClass: 'btn-small btn-gray',
				}, function(start, end, label) {
					event.preventDefault()
					_this.edit_form.start_date = start.format('YYYY-MM-DD');
					_this.edit_form.end_date = end.format('YYYY-MM-DD');
					if($(".repair-edit-usedate-everyday input").val() == "1") {
						_this.edit_form.edit_usedate_txt = '每天';
						_this.edit_form.use_every_day = '1';
						return;
					} else {
						_this.edit_form.edit_usedate_txt = _this.edit_form.start_date + ' ~ ' + _this.edit_form.end_date;
						_this.edit_form.use_every_day = '-1';
					}
				});

				$(".repair-edit-usedate .daterangepicker:last").find(".ranges").prepend(
					'<div class="repair-edit-usedate-everyday">' +
						'<input type="checkbox" />' +
						'<label>每天</label>' +
					'</div>'
				);

				$(".repair-edit-usedate-everyday input").click(function() {
					if($(this).val() == "1") {
						$(this).prop("checked", false);
						$(this).val('');
					} else {
						$(this).prop("checked", true);
						$(this).val('1');
					}
				});
			},
			// 使用时间
			initTime: function() {
				let _this = this;

				let seconds = [];
				for(let i = 0; i < 60; i++) {
					let item = {};
					item.id = (i < 10) ? '0' + i : i;
					item.text = (i < 10) ? '0' + i : i;
					seconds[i] = item;
				};
				let hour = [];
				for(let i = 0; i < 24; i++) {
					let item = {};
					item.id = (i < 10) ? '0' + i : i;
					item.text = (i < 10) ? '0' + i : i;
					hour[i] = item;
				}
				$(_this.$refs.starthour).select2({
					data: hour,
					language: "zh-CN",
					width: 'auto'
				});
				$(_this.$refs.stophour).select2({
					data: hour,
					language: "zh-CN",
					width: 'auto'
				});
				$(_this.$refs.startseconds).select2({
					data: seconds,
					language: "zh-CN",
					width: 'auto'
				});
				$(_this.$refs.stopseconds).select2({
					data: seconds,
					language: "zh-CN",
					width: 'auto'
				})
			},
			openUsetime: function() {
				const _this = this;
				$(_this.$refs.starthour).val(_this.edit_form.start_time.split(':')[0]).trigger('change');
				$(_this.$refs.startseconds).val(_this.edit_form.start_time.split(':')[1]).trigger('change');
				$(_this.$refs.stophour).val(_this.edit_form.end_time.split(':')[0]).trigger('change');
				$(_this.$refs.stopseconds).val(_this.edit_form.end_time.split(':')[1]).trigger('change');
				layer.confirm('', {
					type: 1,
					skin: 'public-alert-skin',
					btn: ['确定', '取消'], // 按钮
					title: '使用时间',
					area: ['450px', ''], // 宽高
					content: $(_this.$refs.repc_usetime_alert)
				}, function() {
					let starthour = $(_this.$refs.starthour).select2("val");
					let startseconds = $(_this.$refs.startseconds).select2("val");
					let stophour = $(_this.$refs.stophour).select2("val");
					let stopseconds = $(_this.$refs.stopseconds).select2("val");
					_this.edit_form.start_time = starthour + ":" + startseconds;
					_this.edit_form.end_time = stophour + ":" + stopseconds;
					if(_this.usetime_allday) {
						_this.edit_form.edit_usetime_txt = '全天';
						_this.edit_form.use_all_day = '1';
					} else {
						if(_this.edit_form.start_time == '00:00' && _this.edit_form.end_time == '00:00') {
							_this.edit_form.edit_usetime_txt = '全天';
							_this.edit_form.use_all_day = '1';
						} else {
							_this.edit_form.edit_usetime_txt = _this.edit_form.start_time + " ~ " + _this.edit_form.end_time;
							_this.edit_form.use_all_day = '-1';
						}
					}
					layer.closeAll();
				});
			},
			// 审批人
			getCheck: function(shop_id) {
				const _this = this;

				Vue.axios.post('User/getList', {
					"header": Vue.request_header,
					"request": {
						"param": {
							"shop_id": shop_id
						}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						_this.check_list = res.data.response.result.user_info;
						// _this.edit_form.check_id = _this.check_list[0].id
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg('出错啦');
				});
			},
			chechAdds() {
				if(this.chech_adds.length >= '9') {
					layer.msg('最多添加10位审批人');
					return false;
				}
				this.chech_adds.push({'check_id': ''});
			},
			checkDel(index) {
				this.chech_adds.splice(index, 1);
			},

			// 列表
			getRepcList(page) {
				const _this = this;

				_this.loading = true;
				let title = '',
					name = '';
				if(_this.repc_list_form.select == '1') {
					title = _this.repc_list_form.content;
				} else {
					name = _this.repc_list_form.content;
				}
				Vue.axios.post('Repair/getApplyRuleList', {
					"header": Vue.request_header,
					"request": {
						"param": {
							"page": page,
							"page_size": _this.GLOBAL.PAGESIZE,
							"shop_id": _this.repc_list_form.shop_id
						}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						if(page == 1) {
							_this.repc_list_total = Number(res.data.response.result.total);
						}
						_this.repc_list = res.data.response.result.rows;
						_this.loading = false;
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg("出错啦");
				});
			},
			// 查询
			repcQuery() {
				this.getRepcList(1);
			},
			// 删除
			repcDel(id) {
				const _this = this;
				layer.confirm('删除后不可恢复，确定删除吗？', {
					btn: ['确定', '取消']
				}, function() {
					Vue.axios.post('Repair/delApplyRule', {
						"header": Vue.request_header,
						"request": {
							"version": Vue.version,
							"param": {
								"id": id
							}
						},
						"comment": ""
					})
					.then(res => {
						if(res.data.response.result_code == "true") {
							layer.msg('删除成功');
							_this.getRepcList(_this.repc_list_page);
						} else {
							Vue.timeoutfun(res.data.response.result_status, _this);
							layer.msg(res.data.response.error_msg);
						}
					})
					.catch(err => {
						layer.msg('出错啦');
					});
				});
			},
			// 点击新增
			repcAdd() {
				const _this = this;
				_this.modify = '1';
				_this.edit_tit = '新增报修审批';
				_this.edit_form = {
					name: '',
					shop_id: _this.shop_list[0].id,
					shop_disabled: false,
					edit_usedate_txt: '每天',
					use_every_day: '1',
					start_date: '',
					end_date: '',
					edit_usetime_txt: '全天',
					use_all_day: '1',
					start_time: '',
					end_time: '',
					check_id: '',
				};
				$(".repair-edit-usedate-everyday input").val("1");
				$(".repair-edit-usedate-everyday input").prop("checked", true);
				_this.usetime_allday = true;
				_this.getCheck(_this.edit_form.shop_id);
				_this.chech_adds = [];
				_this.showList = false;
			},
			// 点击修改
			repcModify(id) {
				const _this = this;

				_this.modify = '2';
				_this.edit_tit = '修改报修审批';
				Vue.axios.post('Repair/getApplyRuleInfos', {
					"header": Vue.request_header,
					"request": {
						"version": Vue.version,
						"param": {
							"id": id
						}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						const row = res.data.response.result;
						_this.edit_id = row.id;
						_this.edit_form.name = row.name;
						_this.edit_form.shop_id = row.shop_id;
						_this.edit_form.shop_disabled = true;
						if(row.use_every_day == '1') {
							_this.edit_form.edit_usedate_txt = '每天';
							_this.edit_form.use_every_day = row.use_every_day;
							_this.edit_form.start_date = '';
							_this.edit_form.end_date = '';
							$(".repair-edit-usedate-everyday input").val("1");
							$(".repair-edit-usedate-everyday input").prop("checked", true);
						} else {
							_this.edit_form.edit_usedate_txt = row.start_date + ' ~ ' + row.end_date;
							_this.edit_form.use_every_day = row.use_every_day;
							_this.edit_form.start_date = row.start_date;
							_this.edit_form.end_date = row.end_date;
							$(".repair-edit-usedate-everyday input").val("");
							$(".repair-edit-usedate-everyday input").prop("checked", false);
						}
						if(row.use_all_day == '1') {
							_this.edit_form.edit_usetime_txt = '全天';
							_this.edit_form.use_all_day = row.use_all_day;
							_this.edit_form.start_time = '00:00';
							_this.edit_form.end_time = '00:00';
							_this.usetime_allday = true;
						} else {
							_this.edit_form.edit_usetime_txt = row.start_time + ' ~ ' + row.end_time;
							_this.edit_form.use_all_day = row.use_all_day;
							_this.edit_form.start_time = row.start_time;
							_this.edit_form.end_time = row.end_time;
							_this.usetime_allday = false;
						}
						_this.getCheck(_this.edit_form.shop_id);
						_this.chech_adds = [];
						row.apply_admin_ids.forEach((v, i) => {
							if(i == 0) {
								console.log(_this.edit_form.check_id);
								_this.edit_form.check_id = v;
								console.log(_this.edit_form.check_id);
							} else {
								_this.chech_adds.push({'check_id': v});
							}
						});
						_this.showList = false;
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg('出错啦');
				});
			},
			editSub() {
				const _this = this;

				let url = "Repair/addApplyRule";
				let apply_admin_ids = [_this.edit_form.check_id];
				_this.chech_adds.forEach(v => {
					apply_admin_ids.push(v.check_id);
				});
				let data = {
					"header": Vue.request_header,
					"request": {
						"param": {
							"name": _this.edit_form.name,
							"shop_id": _this.edit_form.shop_id,
							"use_every_day": _this.edit_form.use_every_day,
							"start_date": _this.edit_form.start_date,
							"end_date": _this.edit_form.end_date,
							"use_all_day": _this.edit_form.use_all_day,
							"start_time": _this.edit_form.start_time,
							"end_time": _this.edit_form.end_time,
							"apply_admin_ids": apply_admin_ids
						}
					},
					"comment": ""
				};
				if(_this.modify == '2') {
					url = Vue.ctUrl + "Repair/editApplyRule";
					data.request.param.id = _this.edit_id;
				}
				Vue.axios({
					method: 'post',
					url: url,
					data: data
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						layer.msg('操作成功');
						_this.getRepcList(_this.repc_list_page);
						_this.showList = true;
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg('出错啦');
				});
			},
			backList() {
				this.showList = true;
			}
		}

	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
	.repc-edit {
		.el-form {
			width: 720px;
			.el-input {
				width: 450px;
				margin: 0 15px 0 0;
			}
		}
		.repair-edit-usedate {
			position: relative;
			.repair-edit-usedate-everyday {
				label {
					margin: 0 0 10px 9px;
					font-weight: normal;
				}
			}
		}
	}
</style>